import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const CHANGE_MULTI_POSTING_ENABLED = 'OFFER :: CHANGE_MULTI_POSTING_ENABLED';

export type TChangeMultiPostingEnabledAction = IReduxAction<typeof CHANGE_MULTI_POSTING_ENABLED, boolean>;

export const changeMultiPostingEnabled = actionGenerator<typeof CHANGE_MULTI_POSTING_ENABLED, boolean>(
  CHANGE_MULTI_POSTING_ENABLED,
);
